module.exports = __webpack_public_path__ + "static/media/006-dentist.7a35003c.svg";